import JsPDF from "jspdf";
import html2canvas from "html2canvas";

export const htmlStringToPdf = async (htmlString) => {
  let iframe = document.createElement("iframe");
  iframe.style.visibility = "hidden";
  iframe.style.width = "1000px"; // Ensure enough space
  document.body.appendChild(iframe);

  let iframedoc = iframe.contentDocument || iframe.contentWindow.document;
  iframedoc.body.innerHTML = htmlString;

  await new Promise((resolve) => setTimeout(resolve, 500)); // Wait for rendering

  let canvas = await html2canvas(iframedoc.body, {
    scale: 2, // Increase resolution for better quality
    useCORS: true,
    windowWidth: iframedoc.body.scrollWidth,
    windowHeight: iframedoc.body.scrollHeight,
  });

  let imgData = canvas.toDataURL("image/png");
  let pdfWidth = canvas.width / 2; // Convert pixels to mm
  let pdfHeight = canvas.height / 2;

  let pdf = new JsPDF("p", "px", [pdfWidth, pdfHeight]); // Dynamic page size

  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

  document.body.removeChild(iframe);
  return pdf.output("blob");
};
